import { useContext } from 'react';

import DisableBlockerContext, { DisableBlockerValues } from './context';

const useDisableBlocker = (): DisableBlockerValues => useContext(DisableBlockerContext);

export default useDisableBlocker;
